var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-2",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('user-table',{on:{"view-profile":_vm.onViewProfile}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }